document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('pre').forEach(function (pre) {
    if (pre.querySelector('.copy-code-btn')) return;

    const button = document.createElement('button');
    button.className = 'copy-code-btn';
    button.textContent = 'Copy';

    button.addEventListener('click', function () {
      const code = pre.querySelector('code');
      if (!code) return;

      navigator.clipboard.writeText(code.innerText).then(function () {
        button.textContent = 'Copied';
        button.classList.add('copied');

        setTimeout(function () {
          button.textContent = 'Copy';
          button.classList.remove('copied');
        }, 1500);
      });
    });

    pre.appendChild(button);
  });
});
